// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App'
import router from './router'

import SetInterval from '@/plugins/SetInterval'

import axios from 'axios'

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.SERVER_URL

Vue.use(SetInterval)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  components: { App },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js